import React, { Component } from 'react';
import { PDFViewer, Page, Text, Image, Document, View, StyleSheet } from '@react-pdf/renderer';

import { CONSTANCIA } from './Styles/Styles';
import logo from "../../assets/img/logo_menu_black.png";

class CulminacionEstS extends Component {
    render() {
        let {datos, numero, folio, tomo, fechaDoc} = this.props;
        const styles = StyleSheet.create(CONSTANCIA[0]);
        let DatPersonales = datos.datosPersonales;
        let nombre2 = "";
        let apellido2 = "";
        (DatPersonales.nombre_2 === null) ? nombre2 = "" : nombre2 = DatPersonales.nombre_2;
        (DatPersonales.apellido_2 === null) ? apellido2 = "" : apellido2 = DatPersonales.apellido_2;
        let Estudiante = `${DatPersonales.nombre_1} ${nombre2} ${DatPersonales.apellido_1} ${apellido2}`;
        let Cedula = `${DatPersonales.nacionalidad} ${DatPersonales.ci}`;
        
        let fecha = () => {
            let fehaEnt = this.props.fecha;
            let fechaPartes = fehaEnt.split("/")
            let meses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre' ]
            return `${fechaPartes[0]} días del mes de ${meses[parseInt(fechaPartes[1]) - 1]} de ${fechaPartes[2]}`
        }

        let fechaS = (date) => {
            let diaActual = new Date(date);
            let day = diaActual.getDate();
            let meses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre' ]
            let month = meses[diaActual.getMonth()];
            let year = diaActual.getFullYear();
        
            return `${day} de ${month} de ${year}`
        }

        return (
            <PDFViewer style={styles.section}>
                <Document title="Constancia de Culminación de Estudios (Simple)">
                    <Page size="letter" style={styles.body}>
                        <View>
                            <Image style={[styles.logo, {marginBottom: 30}]} src={logo} />
                            <Text style={styles.encabezado2}>INSTITUTO UNIVERSITARIO DE DISEÑO LAS MERCEDES</Text>
                            <Text style={styles.encabezado5}>M.E. Nº 130 G.O. Nº 36.719  9 JUNIO 1.999</Text>

                            <Text style={[styles.encabezado2, {marginTop: 20}]}>CONSTANCIA DE CULMINACIÓN DE ESTUDIOS</Text>

                            <Text style={[styles.parrafo, styles.lineH, {marginTop: 20}]}>
                                Quien suscribe, Dra {datos.nameDir}, titular de la Cédula de Identidad V-{datos.cedulaDir}, en su carácter de Directora del Instituto Universitario De Diseño Las Mercedes, hace constar que el (la) ciudadano (a):
                            </Text>

                            <Text style={[styles.nombre, {marginTop: 10, marginBottom: 10}]}>
                                {Estudiante}
                            </Text>

                            <Text style={[styles.parrafo, styles.lineH, {marginTop: 10}]}>
                                Titular de la Cédula de Identidad {Cedula}, cursó en las unidades curriculares correspondientes al Programa de la Carrera {datos.carrera}.
                            </Text>

                            <Text style={[styles.parrafo, styles.lineH, {marginTop: 10}]}>
                                Cumplidas todas las exigencias académicas. obtuvo el Título de Técnico Superior Universitario en {datos.carrera}. El título quedó debidamente registrado en el Libro de Actas de Grado de esta casa de estudios, bajo el N° {numero}, Folio {folio}, Tomo {tomo}; en fecha {fechaS(fechaDoc)}.
                            </Text>

                            <Text style={[styles.parrafo, styles.lineH, {marginTop: 10}]}>
                                Constancia que se expide a solicitud de la parte interesada, en Caracas, a los {fecha()}.
                            </Text>

                            <Text style={[styles.firma, {marginTop: 60}]}> {datos.nameDir}</Text>
                            <Text style={[styles.firma, {marginTop: -5}]}> Directora </Text>

                            <View style={[styles.footer3]}>
                                <View style={[styles.row]}>
                                    <View style={[styles.col11]}>
                                        <Text style={[styles.linea3]}></Text>
                                        <Text style={[styles.encabezado, {fontSize: 7}]}>
                                            Av. Río de Janeiro con Calle Roraima, quinta Los Abuelos, N° 78, Urbanización Chuao, 
                                            C.P.1061  Edo Miranda - Caracas - Venezuela
                                        </Text>
                                        <Text style={[styles.encabezado, {marginTop: -5, fontSize: 7}]}>
                                            Telefax: +58 212 9930983 | 9939139 | 9910710.
                                        </Text>
                                    </View>
                                </View>
                            </View>
                        </View>
                    </Page>
                </Document>
            </PDFViewer>
        );
    }
}

export default CulminacionEstS;


// WEBPACK FOOTER //
// ./src/components/Reportes/CulminacionEstS.jsx